import { useGetMe } from './query/user';
import { getAccessFromRoles } from '../../../../shared/utils/RolesUtils';

const useUserPermission = ({ appName = 'cms', actions = [] } = {}, id, orId, disabled = false) => {
  const { user, userError, isUserFetchError, isUserFetchSuccess, isUserFetching, isUserLoading } =
    useGetMe({ disabled });

  const hasUserAccess = user?.roles?.length
    ? orId
      ? getAccessFromRoles({ appName, actions, isAdmin: user?.isAdmin, id })(user?.roles) ||
        getAccessFromRoles({ appName, actions, isAdmin: user?.isAdmin, id: orId })(user?.roles)
      : getAccessFromRoles({ appName, actions, isAdmin: user?.isAdmin, id })(user?.roles)
    : false;

  return {
    userAccessError: userError,
    isUserAccessFetchError: isUserFetchError,
    isUserAccessFetchSuccess: isUserFetchSuccess,
    isUserAccessFetching: isUserFetching,
    isUserAccessLoading: isUserLoading,
    hasUserAccess,
  };
};

export default useUserPermission;
